
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    DEVICES_IMPORT_GET_DEVICE_MODEL,
    DEVICES_IMPORT_PROCESS_CSV,
    DEVICES_IMPORT_PROCESS_CALAMP_CSV,
    DEVICES_IMPORT_PROCESS_PUI_CSV,
    DEVICES_IMPORT_PROCESS_QUECLINK_CSV,
    DEVICES_IMPORT_LOAD_PHONE_NUMBERS,
    DEVICES_IMPORT_SAVE,
    DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO,
    DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV,
    DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO,
    DEVICES_IMPORT_PROCESS_CEREBRUMX_CSV,
    DEVICES_IMPORT_PROCESS_TELITEK_CSV,
    DEVICES_IMPORT_PROCESS_PACIFIC_TRACK_CSV,
    DEVICES_IMPORT_PROCESS_ZONAR_CSV,
    DEVICES_IMPORT_PROCESS_GENX_CSV,
    DEVICES_IMPORT_PROCESS_DIGITAL_MATTERS_CSV,
    DEVICES_IMPORT_PROCESS_LIGHTMETRICS_CSV,
    DEVICES_IMPORT_PROCESS_M2MD_CSV,
    DEVICES_IMPORT_PROCESS_SMARTWITNESS_CSV
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { getCsvDelimiter } from 'Utils/helpers';
import {
    devicesImportProcessCsvResult,
    devicesImportProcessCsvQueclinkResult,
    devicesImportProcessCalampCsvResult,
    devicesImportGetDeviceModelResult,
    devicesImportLoadPhoneNumbersResult,
    devicesImportSaveResult,
    devicesImportGetCalampDevicesInfoResult,
    devicesImportProcessGeometrisCsvResult,
    devicesImportGetGeometrisDevicesInfoResult
} from 'Redux/actions';


function* processCsvImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexSerial = headerRowClean.indexOf("SERIAL");
        let indexImei = headerRowClean.indexOf("SERIAL");
        let indexICCID = headerRowClean.indexOf("ICCID");
        let indexPhone = headerRowClean.indexOf("MSISDN");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);

            if (j == 0 && lineData.length < 2) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }

            if (lineData.length >= 2) {
                let error = 0;
                let message = "";

                let serial = lineData[indexSerial].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let iccid = indexICCID ? lineData[indexICCID].replace(/(\r\n|\n|\r)/gm, '').trim() : null;
                let phone = indexPhone >= 0 ? lineData[indexPhone].replace(/(\r\n|\n|\r)/gm, '').trim() : null;

                //When serial and imei are empty the line is discarded
                if (serial !== "" && imei !== "") {
                    if (!serial || !imei) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }
                    if (serial !== imei && (imei.length > 17 || imei.length < 14)) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    }

                    let device = {
                        esn: serial,
                        label: serial,
                        imei: imei,
                        iccid: iccid,
                        msisdn: phone,
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false

                    }

                    result.Devices.push(device);
                } else {
                    let device = {
                        esn: serial,
                        imei: imei,
                        Error: 1,
                        Message: "devices_import_missing_imei_or_serial",
                    }
                    result.Devices.push(device);
                }
            }
        }


        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvImportRequest");
    }
}

function* processPUICsvImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexImei = headerRowClean.indexOf("IMEI");
        let indexICCID = headerRowClean.indexOf("ICCID");
        let indexPhone = headerRowClean.indexOf("MSISDN");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);

            if (j == 0 && lineData.length < 2) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }

            if (lineData.length >= 2) {
                let error = 0;
                let message = "";

                let serial = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let iccid = indexICCID != -1 ? lineData[indexICCID].replace(/(\r\n|\n|\r)/gm, '').trim() : null;
                let phone = indexPhone != -1 ? lineData[indexPhone].replace(/(\r\n|\n|\r)/gm, '').trim() : null;

                if (!serial || !imei) {
                    error = 1;
                    message = "devices_import_file_not_supported"
                }

                if (imei.length > 17 || imei.length < 14) {
                    error = 1;
                    message = "devices_import_invalid_imei";
                }

                let device = {
                    esn: serial.replace('"', '').replace('"', ''),
                    label: serial.replace('"', '').replace('"', ''),
                    imei: imei.replace('"', '').replace('"', ''),
                    iccid: iccid.replace('"', '').replace('"', ''),
                    msisdn: phone.replace('"', '').replace('"', ''),
                    Error: error,
                    Message: message,
                    Selected: error === 0 ? true : false
                }

                result.Devices.push(device);
            }
        }


        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processPUICsvImportRequest");
    }
}

function* processCsvQueclinkImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexImei = headerRowClean.indexOf("IMEI");
        let indexICCID = headerRowClean.indexOf("ICCID");
        let indexPhone = headerRowClean.indexOf("MSISDN");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);

            if (j == 0 && lineData.length < 2) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }

            if (lineData.length >= 2) {
                let error = 0;
                let message = "";

                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let iccid = indexICCID ? lineData[indexICCID].replace(/(\r\n|\n|\r)/gm, '').trim() : null;
                let phone = indexPhone >= 0 ? lineData[indexPhone].replace(/(\r\n|\n|\r)/gm, '').trim() : null;

                //When serial and imei are empty the line is discarded
                if (imei !== "") {
                    if (!imei) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }

                    if ((imei.length !== 15)) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    }

                    let device = {
                        esn: imei,
                        label: imei,
                        imei: imei,
                        iccid: iccid,
                        msisdn: phone,
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false
                    }

                    result.Devices.push(device);
                } else {
                    let device = {
                        ens: imei,
                        imei: imei,
                        Error: 1,
                        Message: "devices_import_missing_imei_or_serial",
                    }
                    result.Devices.push(device);
                }
            }
        }


        yield put(devicesImportProcessCsvQueclinkResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvQueclinkResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvQueclinkImportRequest");
    }
}

function* processCalampCsvImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData, partNumbers, simProvider } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);
        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexSerial = headerRowClean.indexOf("ESN");
        let indexIccid = headerRowClean.indexOf("ICCID");
        let indexMsisdn = headerRowClean.indexOf("MSISDN");
        let indexLabel = headerRowClean.indexOf("LABEL");
        let devicesFromFile = [];
        let devicesToSearch = [];

        lines.shift();

        //to read each ENS to make a consult to read the
        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            if (!line) {
                continue;
            }

            let lineData = line.split(delimiter);
            let error = 0;
            let message = "";
            let serial = indexSerial !== -1 ? lineData[indexSerial].replace(/(\r\n|\n|\r)/gm, '').trim() : lineData[0]; //ESN
            let msisdn = indexMsisdn !== -1 ? lineData[indexMsisdn] ? lineData[indexMsisdn].replace(/(\r\n|\n|\r)/gm, '').trim() : "" : ""; //MIN
            let iccid = indexIccid !== -1 ? lineData[indexIccid] ? lineData[indexIccid].replace(/(\r\n|\n|\r)/gm, '').trim() : "" : ""; //ICC-ID

            let label = indexLabel !== -1 ? lineData[indexLabel] ? lineData[indexLabel].replace(/(\r\n|\n|\r)/gm, '').trim() : "" : ""; //LABEL

            let deviceModel = null//lineData[16].replace(/(\r\n|\n|\r)/gm, '').trim();
            let regx = /[^a-zA-Z0-9]/g;
            let device = {}

            device.esn = serial.replace(regx, '');;
            device.msisdn = msisdn.replace(regx, '');
            device.iccid = iccid.replace(regx, '');

            device.label = label && label !== "" ? label : serial.replace(regx, '');

            devicesFromFile.push(device);
            devicesToSearch.push(device.esn);
        }

        //search to find the devices basic information for calamp
        const QUERY = `
        query  ($esns: [String]!) {
            result: searchCalampDevices (esns: $esns) {
                devices {
                    esn
                    status
                    deviceModelId
                    partNumber
                    iccid
                    imei
                    pulsCustomerId
                    scriptVersion
                    configVersion
                    firmwareId
                    calampApi
                    accountId
                }
                deviceModels {
                    id
                    name
                    manufacturerId
                    manufacturer {
                        id
                        name
                    }
                    product
                    geofence
                    input
                    output
                    ota
                    sms
                    starter
                    driverBehavior
                    battery
                    analytic
                    promiles
                    comData
                    pressurePro
                    vbus
                    jbus
                    obd2Alerts
                    motion
                    tow
                    ttu
                    hoursEnable
                    odometerEnable
                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                    cariq
                    carbEnable
                }
              }
            }
            `

        const pulsDevicesInfo = yield call(
            clientQuery,
            QUERY,
            {
                esns: devicesToSearch
            },
            endpoints.GRAPHQL_GENERAL,
        );


        //load each device readed and 
        if (pulsDevicesInfo.result && pulsDevicesInfo?.result?.devices) {
            for (let i = 0; i < devicesFromFile.length; i++) {
                //for (let i = 0; i < pulsDevicesInfo.Devices.Items.length; i++) {
                let devFile = devicesFromFile[i] //.find(x => x.ESN === dev.ESN)
                let dev = pulsDevicesInfo.result.devices.find(x => x.esn === devFile.esn);

                if (!dev) {
                    dev = devFile;
                    dev.Error = 1;
                    dev.Message = "devices_import_device_not_found";
                    result.Devices.push(dev);

                } else if (dev.status !== "OK") {
                    dev = JSON.parse(JSON.stringify(dev))

                    // Set the iccid and label from the file
                    dev.label = devFile.label;
                    dev.iccid = devFile.iccid;

                    dev.Error = 1;
                    dev.Status = dev.status;
                    dev.Message = dev.status;
                    result.Devices.push(dev);
                } else {
                    dev = JSON.parse(JSON.stringify(dev))

                    let error = 0;
                    let message = "";

                    let deviceModel = pulsDevicesInfo?.result?.deviceModels?.find(x => x.id === dev.deviceModelId) || null;//lineData[16].replace(/(\r\n|\n|\r)/gm, '').trim();
                    //let purchaseOrder = dev.PO === null ? "" : dev.PO; //PO

                    // is prority the iccid from the file
                    if (devFile && devFile.iccid && devFile.iccid !== "") {
                        dev.iccid = devFile.iccid;
                    }
                    // is prority the msisdn from the file
                    if (devFile && devFile.msisdn && devFile.msisdn !== "")
                        dev.msisdn = devFile.msisdn;

                    if (!dev.esn) {
                        error = 1;
                        message = "devices_import_invalid_esn";
                        //updated for calamp devices
                    } else if (!dev.imei || dev.imei.length < 14 || dev.imei.length > 18) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    } else if (!deviceModel) {
                        error = 1;
                        message = "devices_import_invalid_device_model";
                    } else if (!dev.pulsCustomerId && dev.calampApi !== "CTC") {
                        error = 1;
                        message = "devices_import_invalid_puls_customer";
                    }
                    dev.label = dev.esn;
                    dev.deviceModel = deviceModel;
                    //PurchaseOrder: purchaseOrder,

                    dev.Error = error;
                    dev.Message = message;

                    if (!deviceModel) {

                        dev.Error = 1;
                        dev.Message = "devices_import_invalid_device_model";
                    }
                    dev.unitConfig = {
                        configVersion: dev.configVersion,
                        scriptVersion: dev.scriptVersion,
                        pulsCustomerId: dev.pulsCustomerId,
                        calampApi: dev.calampApi,
                        accountId: dev.accountId,
                    }
                    //to show part number always, not only on error


                    result.Devices.push(dev);
                }
            }
        }

        if (!result.Devices.length) {
            result.Error = 1;
            result.ErrorMessage = "devices_import_file_not_supported";
        }


        yield put(devicesImportProcessCalampCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCalampCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCalampCsvImportRequest");
    }
}

function* getDeviceModel({ payload }) {
    try {

        const { deviceModelId } = payload

        const QUERY = `
        query getDeviceModel ($id: Int!) {
            result: getDeviceModel (id: $id) {
                id
                name
                manufacturerId
                manufacturer {
                    id
                    name
                }
                unitTypeId
                product
                geofence
                input
                output
                ota
                sms
                starter
                driverBehavior
                battery
                analytic
                promiles
                comData
                pressurePro
                vbus
                jbus
                obd2Alerts
                motion
                tow
                ttu
                hoursEnable
                odometerEnable
                cariq
                carbEnable
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: deviceModelId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(devicesImportGetDeviceModelResult(data?.result))

    } catch (exc) {
        yield put(devicesImportGetDeviceModelResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/importDevices/redux/saga",
            "getDeviceModel",
        )
    }
}

const MAX_ICCIDS_PER_BATCH = 75;

const GET_SIM_DETAILS_BATCH = `
    query getSimDetailsBatch($iccids: [String!]!) {
        result: getSimDetailsBatch(iccids: $iccids) {
            results {
                iccid
                details
                status
                error
            }
            totalRequested
            totalSuccessful
            totalFailed
        }
    }
`;

function markSimError(devices, index) {
    devices[index] = {
        ...devices[index],
        StatusSIM: "Error",
        MessageSIM: "devices_import_retreving_sim_info_error",
        ErrorSIM: 2,
    };
}

function* loadPhoneNumbers({ payload }) {
    try {
        const { devices } = payload;

        const iccidToIndices = new Map();
        const uniqueIccids = [];

        for (let index = 0; index < devices.length; index++) {
            const iccid = devices[index]?.iccid?.trim();

            if (!iccid) {
                markSimError(devices, index);
                continue;
            }

            if (!iccidToIndices.has(iccid)) {
                iccidToIndices.set(iccid, []);
                uniqueIccids.push(iccid);
            }
            iccidToIndices.get(iccid).push(index);
        }

        if (uniqueIccids.length === 0) {
            yield put(devicesImportLoadPhoneNumbersResult(devices));
            return;
        }

        const chunks = [];
        for (let i = 0; i < uniqueIccids.length; i += MAX_ICCIDS_PER_BATCH) {
            chunks.push(uniqueIccids.slice(i, i + MAX_ICCIDS_PER_BATCH));
        }

        for (const chunkIccids of chunks) {
            let data = yield call(
                clientQuery,
                GET_SIM_DETAILS_BATCH,
                { iccids: chunkIccids },
                endpoints.GRAPHQL_GENERAL,
            );

            const results = data?.result?.results || [];
            const seen = new Set();

            for (const item of results) {
                seen.add(item.iccid);
                const indices = iccidToIndices.get(item.iccid) || [];

                let SIMInfo = null;
                if (item.status === 'success' && item.details) {
                    try {
                        SIMInfo = typeof item.details === 'string'
                            ? JSON.parse(item.details)
                            : item.details;
                    } catch (e) {
                        SIMInfo = null;
                    }
                }

                for (const index of indices) {
                    if (SIMInfo) {
                        devices[index] = {
                            ...devices[index],
                            msisdn: SIMInfo.msisdn,
                            StatusSIM: "Completed",
                            MessageSIM: "devices_import_load_phone_number_success",
                            ErrorSIM: 4,
                        };
                    } else {
                        markSimError(devices, index);
                    }
                }
            }

            for (const iccid of chunkIccids) {
                if (!seen.has(iccid)) {
                    for (const index of (iccidToIndices.get(iccid) || [])) {
                        markSimError(devices, index);
                    }
                }
            }
        }

        yield put(devicesImportLoadPhoneNumbersResult(devices));

    } catch (exc) {
        yield put(devicesImportLoadPhoneNumbersResult([]));

        ExceptionManager(exc, "Modules/devices/.components/import/redux/saga/", "loadPhoneNumbersImport");
    }
}

function* importDevicesRequest({ payload }) {
    let result = {};
    try {
        //```get paramters
        const { manufacturer, account, simProviderAccount, reference, devices, timezoneId, tagIds } = payload;

        let devicesToSave = [];

        //format the devices with the correct structure to save
        for (let index in devices) {
            let device = devices[index]

            let tempIMEI = device.imei
            if (!tempIMEI || tempIMEI === "")
                if (manufacturer.name.toUpperCase() === "Geometris".toUpperCase() || manufacturer.name.toUpperCase() === "Global Star".toUpperCase() || manufacturer.name.toUpperCase() === "SmartWitness".toUpperCase())
                    tempIMEI = device.esn


            //features


            //create objet to save
            let deviceData = {
                label: device?.label,
                esn: device?.esn,
                imei: tempIMEI,
                iccid: device?.iccid,
                msisdn: device?.msisdn,
                simProviderAccountId: device?.simProviderAccount ? device.simProviderAccount.id : simProviderAccount ? simProviderAccount.id : null,
                timezoneId: timezoneId,

                deviceModelId: device?.deviceModel?.id,
                reference: reference,
                deviceCategory: device?.deviceCategory,// ? "Asset" : "Fleet"
                network: device.network,

                //features
                promiles: device.promiles,
                promilesOdometerCalculated: device.promilesOdometerCalculated,
                comdata: device.comdata,
                apu: device.apu,
                hybrid: device.hybrid,
                vbus: device.vbus,
                jbus: device.jbus,
                useEcuOdometer: device.useEcuOdometer,
                useEcuEngineHours: device.useEcuEngineHours,
                useEcuSpeed: device.useEcuSpeed,
                useEcuVin: device.useEcuVin,
                driverBehavior: device.driverBehavior,
                show: device.show,
                linkedMode: device.linkedMode,
                cariq: device.cariq,
            }

            if (device.unitConfig) {
                deviceData.unitConfig = device.unitConfig;
                if (device.packageName)
                    deviceData.unitConfig.packageName = device.packageName;
            } else if (!device.unitConfig && device.packageName)
                deviceData.unitConfig = { packageName: device.packageName }

            devicesToSave.push(deviceData);
        }

        const importDevices = yield call(
            clientMutation,
            `mutation ($manufacturerId: Int!, $companyId: Int!, $units: [UnitImportInput], $tagIds: [Int]
              ) {
              DevicesResult: importUnits(manufacturerId: $manufacturerId, companyId: $companyId, units: $units, tagIds: $tagIds) {
                stepFunctionId
                transactionId
                transactionType
                processStartDate
              }
            }`,
            {
                manufacturerId: manufacturer.id,
                companyId: account.id,
                units: devicesToSave,
                tagIds: tagIds
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(devicesImportSaveResult(importDevices));

    } catch (exc) {
        //```always return empty data
        yield put(devicesImportSaveResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/import/redux/saga/", "importDevicesRequest");
    }
}

function* getCalampDeviceInfoImportRequest({ payload }) {
    let result = [];
    let devices = [];
    try {
        //```get paramters
        const { data } = payload;

        let QUERY = `query  ($esns: [String]!) {
        result: searchCalampDevices (esns: $esns) {
            devices {
                esn
                status
                deviceModelId
                partNumber
                iccid
                imei
                pulsCustomerId
                scriptVersion
                configVersion
                firmwareId
                network
                calampApi
                accountId
            }
            deviceModels {
                id
                name
                manufacturerId
                manufacturer {
                    id
                    name
                }
                product
                geofence
                input
                output
                ota
                sms
                starter
                driverBehavior
                battery
                analytic
                promiles
                comData
                pressurePro
                vbus
                jbus
                obd2Alerts
                motion
                tow
                ttu
                hoursEnable
                odometerEnable
                createdBy
                createdOn
                updatedBy
                updatedOn
                cariq
                carbEnable
            }
          }
        }
        `;


        const pulsDevicesInfo = yield call(
            clientQuery,
            QUERY,
            {
                esns: data.Imeis
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (pulsDevicesInfo.result && pulsDevicesInfo?.result?.devices) {
            let devices = pulsDevicesInfo.result.devices;
            let deviceModels = pulsDevicesInfo?.result?.deviceModels || [];
            devices.map((item, index) => {
                let dev = JSON.parse(JSON.stringify(item))
                if (dev.status !== "OK") {
                    dev.Error = 1;
                    dev.Status = dev.status;
                    dev.Message = dev.status;
                    dev.simProviderAccount = data.simProviderAccount;
                } else {
                    let devModel = deviceModels.find(x => x.id === dev.deviceModelId);
                    dev.deviceModel = devModel;
                    dev.label = dev.esn;
                    dev.simProviderAccount = data.simProviderAccount;
                    dev.unitConfig = {
                        configVersion: dev.configVersion,
                        scriptVersion: dev.scriptVersion,
                        pulsCustomerId: dev.pulsCustomerId,
                        calampApi: dev.calampApi,
                        accountId: dev.accountId,
                    }
                }
                result.push(dev);
            });

        }

        yield put(devicesImportGetCalampDevicesInfoResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportGetCalampDevicesInfoResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/import/redux/saga/", "getCalampDeviceInfoImportRequest", true);
    }
}

function* processGeometrisCsvImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);
        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexSerial = headerRowClean.indexOf("ESN");
        let indexIccid = headerRowClean.indexOf("ICCID");
        let indexMsisdn = headerRowClean.indexOf("MSISDN");
        let devicesFromFile = [];
        let devicesToSearch = [];

        lines.shift();

        //to read each ENS to make a consult to read the
        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            if (!line) {
                continue;
            }

            let lineData = line.split(delimiter);
            let error = 0;
            let message = "";
            let serial = indexSerial !== -1 ? lineData[indexSerial].replace(/(\r\n|\n|\r)/gm, '').trim() : lineData[0]; //ESN
            let msisdn = indexMsisdn !== -1 ? lineData[indexMsisdn].replace(/(\r\n|\n|\r)/gm, '').trim() : ""; //MIN
            let iccid = indexIccid !== -1 ? lineData[indexIccid].replace(/(\r\n|\n|\r)/gm, '').trim() : ""; //ICC-ID
            let deviceModel = null//lineData[16].replace(/(\r\n|\n|\r)/gm, '').trim();
            let regx = /[^a-zA-Z0-9]/g;
            let device = {}

            device.esn = serial.replace(regx, '');;
            device.msisdn = msisdn.replace(regx, '');
            device.iccid = iccid.replace(regx, '');
            devicesFromFile.push(device);
            devicesToSearch.push(device.esn);
        }

        //search to find the devices basic information for calamp
        const QUERY = `
        query  ($esns: [String]!) {
            result: searchGeometrisDevices (esns: $esns) {
                devices {
                    esn
                    status
                    deviceModelId
                    network
                    partNumber
                    iccid
                    msisdn
                    imei
                }
                deviceModels {
                    id
                    name
                    manufacturerId
                    manufacturer {
                        id
                        name
                    }
                    product
                    geofence
                    input
                    output
                    ota
                    sms
                    starter
                    driverBehavior
                    battery
                    analytic
                    promiles
                    comData
                    pressurePro
                    vbus
                    jbus
                    obd2Alerts
                    motion
                    tow
                    ttu
                    hoursEnable
                    odometerEnable
                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                    cariq
                    carbEnable
                }
              }
            }
            `

        const pulsDevicesInfo = yield call(
            clientQuery,
            QUERY,
            {
                esns: devicesToSearch
            },
            endpoints.GRAPHQL_GENERAL,
        );


        //load each device readed and 
        if (pulsDevicesInfo.result && pulsDevicesInfo?.result?.devices) {
            for (let i = 0; i < devicesFromFile.length; i++) {
                //for (let i = 0; i < pulsDevicesInfo.Devices.Items.length; i++) {
                let devFile = devicesFromFile[i] //.find(x => x.ESN === dev.ESN)
                let dev = pulsDevicesInfo.result.devices.find(x => x.esn === devFile.esn);
                if (!dev) {
                    dev = devFile;
                    dev.Error = 1;
                    dev.Message = "devices_import_device_not_found";
                    result.Devices.push(dev);

                } else if (dev.status !== "OK") {
                    dev = JSON.parse(JSON.stringify(dev))

                    dev.Error = 1;
                    dev.Status = dev.status;
                    dev.Message = dev.status;

                    result.Devices.push(dev);
                } else {
                    let error = 0;
                    let message = "";

                    dev = JSON.parse(JSON.stringify(dev))

                    let deviceModel = pulsDevicesInfo.result.deviceModels.find(x => x.id === dev.deviceModelId)//lineData[16].replace(/(\r\n|\n|\r)/gm, '').trim();
                    //let purchaseOrder = dev.PO === null ? "" : dev.PO; //PO

                    // is prority the iccid from the file
                    if (devFile && devFile.iccid && devFile.iccid !== "") {
                        dev.iccid = devFile.iccid;
                    }
                    // is prority the msisdn from the file
                    if (devFile && devFile.msisdn && devFile.msisdn !== "")
                        dev.msisdn = devFile.msisdn;

                    if (!dev.esn) {
                        error = 1;
                        message = "devices_import_invalid_esn";
                        //updated for calamp devices
                    } else if (!dev.imei || dev.imei.length < 14 || dev.imei.length > 18) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    } else if (!deviceModel) {
                        error = 1;
                        message = "devices_import_invalid_device_model";
                    }
                    dev.label = dev.esn;
                    dev.deviceModel = deviceModel;
                    //PurchaseOrder: purchaseOrder,

                    dev.Error = error;
                    dev.Message = message;

                    if (!deviceModel) {

                        dev.Error = 1;
                        dev.Message = "devices_import_invalid_device_model";
                    }
                    result.Devices.push(dev);
                }
            }
        }

        if (!result.Devices.length) {
            result.Error = 1;
            result.ErrorMessage = "devices_import_file_not_supported";
        }


        yield put(devicesImportProcessGeometrisCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessGeometrisCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processGeometridCsvImportRequest", true);
    }
}

function* getGeometrisDeviceInfoImportRequest({ payload }) {
    let result = [];
    let devices = [];
    try {
        //```get paramters
        const { data } = payload;

        let QUERY = `query  ($esns: [String]!) {
        result: searchGeometrisDevices (esns: $esns) {
            devices {
                esn
                status
                deviceModelId
                network
                partNumber
                iccid
                msisdn
                imei
            }
            deviceModels {
                id
                name
                manufacturerId
                manufacturer {
                    id
                    name
                }
                product
                geofence
                input
                output
                ota
                sms
                starter
                driverBehavior
                battery
                analytic
                promiles
                comData
                pressurePro
                vbus
                jbus
                obd2Alerts
                motion
                tow
                ttu
                hoursEnable
                odometerEnable
                createdBy
                createdOn
                updatedBy
                updatedOn
                cariq
                carbEnable
            }
          }
        }
        `;


        const pulsDevicesInfo = yield call(
            clientQuery,
            QUERY,
            {
                esns: data.Imeis
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (pulsDevicesInfo.result && pulsDevicesInfo?.result?.devices) {
            let devices = pulsDevicesInfo.result.devices;
            let deviceModels = pulsDevicesInfo.result.deviceModels;
            devices.map((item, index) => {
                let dev = JSON.parse(JSON.stringify(item))
                if (dev.status !== "OK") {
                    dev.Error = 1;
                    dev.Status = dev.status;
                    dev.Message = dev.status;
                    dev.simProviderAccount = data.simProviderAccount;
                } else {
                    let devModel = deviceModels.find(x => x.id === dev.deviceModelId);
                    dev.deviceModel = devModel;
                    dev.label = dev.esn;
                    dev.simProviderAccount = data.simProviderAccount;
                }
                result.push(dev);
            });

        }

        yield put(devicesImportGetGeometrisDevicesInfoResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportGetGeometrisDevicesInfoResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/import/redux/saga/", "getGeometrisDeviceInfoImportRequest"), true;
    }
}

function* processCerebrumXCsvImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };
    const packages = ["PREMIUM", "ADVANCED", "BASIC"]

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexImei = headerRowClean.indexOf("VIN");
        let indexPackageName = headerRowClean.indexOf("PACKAGENAME");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);

            if (j == 0 && lineData.length < 2) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }

            if (lineData.length >= 2) {
                let error = 0;
                let message = "";

                let serial = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let packageName = indexPackageName != -1 ? lineData[indexPackageName].replace(/(\r\n|\n|\r)/gm, '').trim() : null;

                if (!serial || !imei) {
                    error = 1;
                    message = "devices_import_file_not_supported"
                }
                const regex = /^(?=.*[0-9])(?=.*[A-z])[0-9A-z-]{17}$/

                if (!regex.test(serial)) {
                    error = 1;
                    message = "devices_import_invalid_vin";
                }

                if (!packageName || !packages.find(x => x.toUpperCase() == packageName.toUpperCase())) {
                    error = 1;
                    message = "devices_import_invalid_package_name";
                }

                let device = {
                    esn: serial.replace('"', '').replace('"', ''),
                    label: serial.replace('"', '').replace('"', ''),
                    imei: imei.replace('"', '').replace('"', ''),
                    packageName: packageName.replace('"', '').replace('"', ''),
                    Error: error,
                    Message: message,
                    Selected: error === 0 ? true : false
                }

                result.Devices.push(device);
            }
        }


        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processPUICsvImportRequest");
    }
}

function* processCsvTelitekImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexSerial = headerRowClean.indexOf("SERIAL");
        let indexImei = headerRowClean.indexOf("IMEI");
        let indexICCID = headerRowClean.indexOf("ICCID");
        let indexPhone = headerRowClean.indexOf("MSISDN");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);

            if (j == 0 && lineData.length < 2) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }

            if (lineData.length >= 2) {
                let error = 0;
                let message = "";

                let serial = lineData[indexSerial].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let iccid = indexICCID ? lineData[indexICCID].replace(/(\r\n|\n|\r)/gm, '').trim() : null;
                let phone = indexPhone >= 0 ? lineData[indexPhone].replace(/(\r\n|\n|\r)/gm, '').trim() : null;

                //When serial and imei are empty the line is discarded
                if (serial !== "" && imei !== "") {
                    if (!serial || !imei) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }
                    if (serial && (serial.length > 15 || serial.length < 3)) {
                        error = 1;
                        message = "devices_import_invalid_esn";
                        //updated for calamp devices
                    }
                    if (imei && (imei.length > 17 || imei.length < 14)) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    }

                    let device = {
                        esn: serial.replace('"', '').replace('"', ''),
                        label: serial.replace('"', '').replace('"', ''),
                        imei: imei.replace('"', '').replace('"', ''),
                        iccid: iccid.replace('"', '').replace('"', ''),
                        msisdn: phone.replace('"', '').replace('"', ''),
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false

                    }

                    result.Devices.push(device);
                } else {
                    let device = {
                        esn: serial,
                        imei: imei,
                        Error: 1,
                        Message: "devices_import_missing_imei_or_serial",
                    }
                    result.Devices.push(device);
                }
            }
        }


        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvTelitekImportRequest");
    }
}

function* processCsvPacificTrackImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexImei = headerRowClean.indexOf("IMEI");
        let indexICCID = headerRowClean.indexOf("ICCID");
        let indexPhone = headerRowClean.indexOf("MSISDN");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);

            if (j == 0 && lineData.length < 3) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }

            if (lineData.length >= 3) {
                let error = 0;
                let message = "";

                let serial = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let iccid = indexICCID ? lineData[indexICCID].replace(/(\r\n|\n|\r)/gm, '').trim() : null;
                let phone = indexPhone >= 0 ? lineData[indexPhone].replace(/(\r\n|\n|\r)/gm, '').trim() : null;

                //When serial and imei are empty the line is discarded
                if (serial !== "" && imei !== "") {
                    if (!serial || !imei) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }
                    if (imei && (imei.length > 17 || imei.length < 14)) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    }

                    let device = {
                        esn: serial.replace('"', '').replace('"', ''),
                        label: serial.replace('"', '').replace('"', ''),
                        imei: imei.replace('"', '').replace('"', ''),
                        iccid: iccid.replace('"', '').replace('"', ''),
                        msisdn: phone.replace('"', '').replace('"', ''),
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false

                    }

                    result.Devices.push(device);
                } else {
                    let device = {
                        esn: serial,
                        imei: imei,
                        Error: 1,
                        Message: "devices_import_missing_imei_or_serial",
                    }
                    result.Devices.push(device);
                }
            }
        }


        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvPacificTrackImportRequest");
    }
}

function* processCsvZonarImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexSerial = headerRowClean.indexOf("SERIAL");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);
            if (j == 0 && lineData.length < 1) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }

            if (lineData.length > 0 && lineData[0].length > 0) {
                let error = 0;
                let message = "";

                let serial = lineData[indexSerial].replace(/(\r\n|\n|\r)/gm, '').trim();
                
                //When serial and imei are empty the line is discarded
                if (serial !== "") {
                    if (!serial) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }
                    if (serial && (serial.length > 17 || serial.length < 6)) {
                        error = 1;
                        message = "devices_import_invalid_esn";
                    }

                    let device = {
                        esn: serial.replace('"', '').replace('"', ''),
                        label: serial.replace('"', '').replace('"', ''),
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false

                    }

                    result.Devices.push(device);
                }
            }
        }

        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvZonarImportRequest");
    }
}

function* processCsvGenXImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexSerial = headerRowClean.indexOf("SERIAL");
        let indexImei = headerRowClean.indexOf("IMEI");
        let indexICCID = headerRowClean.indexOf("ICCID");
        let indexPhone = headerRowClean.indexOf("MSISDN");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);

            if (j == 0 && lineData.length < 2) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }

            if (lineData.length >= 2) {
                let error = 0;
                let message = "";

                let serial = lineData[indexSerial].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let iccid = indexICCID ? lineData[indexICCID].replace(/(\r\n|\n|\r)/gm, '').trim() : null;
                let phone = indexPhone >= 0 ? lineData[indexPhone].replace(/(\r\n|\n|\r)/gm, '').trim() : null;

                //When serial and imei are empty the line is discarded
                if (serial !== "" && imei !== "") {
                    if (!serial || !imei) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }
                    if (serial && (serial.length > 15 || serial.length < 3)) {
                        error = 1;
                        message = "devices_import_invalid_esn";
                        //updated for calamp devices
                    }
                    if (imei && (imei.length > 17 || imei.length < 14)) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    }

                    let device = {
                        esn: serial.replace('"', '').replace('"', ''),
                        label: serial.replace('"', '').replace('"', ''),
                        imei: imei.replace('"', '').replace('"', ''),
                        iccid: iccid.replace('"', '').replace('"', ''),
                        msisdn: phone.replace('"', '').replace('"', ''),
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false

                    }

                    result.Devices.push(device);
                } else {
                    let device = {
                        esn: serial,
                        imei: imei,
                        Error: 1,
                        Message: "devices_import_missing_imei_or_serial",
                    }
                    result.Devices.push(device);
                }
            }
        }


        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvGenXImportRequest");
    }
}

function* processCsvDigitalMattersImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexImei = headerRowClean.indexOf("IMEI");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);
            if (j == 0 && lineData.length < 1) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }
            
            if (lineData.length > 0 && lineData[0].length > 0) {
                let error = 0;
                let message = "";

                let serial = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                
                //When serial and imei are empty the line is discarded
                if (serial !== "" && imei !== "") {
                    if (!serial || !imei) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }
                    if (imei && (imei.length > 17 || imei.length < 6)) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    }

                    let device = {
                        esn: serial.replace('"', '').replace('"', ''),
                        label: serial.replace('"', '').replace('"', ''),
                        imei: imei.replace('"', '').replace('"', ''),
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false

                    }

                    result.Devices.push(device);
                } else {
                    let device = {
                        esn: serial,
                        imei: imei,
                        Error: 1,
                        Message: "devices_import_missing_imei_or_serial",
                    }
                    result.Devices.push(device);
                }
            }
        }


        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvDigitalMattersImportRequest");
    }
}
function* processCsvLightMetricsImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexImei = headerRowClean.indexOf("IMEI");

        lines.shift();

        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);
            if (j == 0 && lineData.length < 1) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }

            if (lineData.length > 0 && lineData[0].length > 0) {
                let error = 0;
                let message = "";

                let serial = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                
                //When serial and imei are empty the line is discarded
                if (serial !== "" && imei !== "") {
                    if (!serial || !imei) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }
                    if (imei && (imei.length > 17 || imei.length < 6)) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    }

                    let device = {
                        esn: serial.replace('"', '').replace('"', ''),
                        label: serial.replace('"', '').replace('"', ''),
                        imei: imei.replace('"', '').replace('"', ''),
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false

                    }

                    result.Devices.push(device);
                } else {
                    let device = {
                        esn: serial,
                        imei: imei,
                        Error: 1,
                        Message: "devices_import_missing_imei_or_serial",
                    }
                    result.Devices.push(device);
                }
            }
        }


        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvLightMetricsImportRequest");
    }
}

function* processCsvM2MDImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexImei = headerRowClean.indexOf("IMEI");
        let indexICCID = headerRowClean.indexOf("ICCID");
        

        lines.shift();
        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);
            if (j == 0 && lineData.length < 1) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }
            
            if (lineData.length > 0 && lineData[0].length > 0) {
                let error = 0;
                let message = "";

                let serial = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let iccid = indexICCID ? lineData[indexICCID].replace(/(\r\n|\n|\r)/gm, '').trim() : null;
                
                //When serial and imei are empty the line is discarded
                if (serial !== "" && imei !== "") {
                    if (!serial || !imei) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }
                    if (imei && (imei.length > 17 || imei.length < 6)) {
                        error = 1;
                        message = "devices_import_invalid_imei";
                    }

                    let device = {
                        esn: serial.replace('"', '').replace('"', ''),
                        label: serial.replace('"', '').replace('"', ''),
                        imei: imei.replace('"', '').replace('"', ''),
                        iccid: iccid ? iccid.replace('"', '').replace('"', '') : null,
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false

                    }

                    result.Devices.push(device);
                } else {
                    let device = {
                        esn: serial,
                        imei: imei,
                        Error: 1,
                        Message: "devices_import_missing_imei_or_serial",
                    }
                    result.Devices.push(device);
                }
            }
        }
        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvM2MDImportRequest");
    }
}

function* processCsvSmartWitnessImportRequest({ payload }) {
    let result = {
        Devices: [],
        Error: 0,
        ErrorMessage: null
    };

    try {
        const { cvsData } = payload;

        var lines = cvsData.split('\n');
        const delimiter = getCsvDelimiter(lines[0]);

        let headerRaw = Array.from(lines[0].split(delimiter), x => x.replace(/['"]+/g, '', ''));
        let headerRowClean = [];

        headerRaw.map((item, index) => {
            headerRowClean.push(item.replace(/(\r\n|\n|\r)/gm, ''));
        })

        let indexImei = headerRowClean.indexOf("DRID");
        let indexICCID = headerRowClean.indexOf("ICCID");
        

        lines.shift();
        for (let j = 0; j < lines.length; j++) {
            let line = lines[j];
            let lineData = line.split(delimiter);
            if (j == 0 && lineData.length < 1) {
                result.Error = 1;
                result.ErrorMessage = "devices_import_file_not_supported";
                break;
            }
            
            if (lineData.length > 0 && lineData[0].length > 0) {
                let error = 0;
                let message = "";

                let serial = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let imei = lineData[indexImei].replace(/(\r\n|\n|\r)/gm, '').trim();
                let iccid = indexICCID ? lineData[indexICCID].replace(/(\r\n|\n|\r)/gm, '').trim() : null;
                
                //When serial and imei are empty the line is discarded
                if (serial !== "" && imei !== "") {
                    if (!serial || !imei) {
                        error = 1;
                        message = "devices_import_file_not_supported"
                    }
                    if (imei && (imei.length > 16 || imei.length < 12)) {
                        error = 1;
                        message = "devices_import_invalid_serial_drid";
                    }

                    let device = {
                        esn: serial.replace('"', '').replace('"', ''),
                        label: serial.replace('"', '').replace('"', ''),
                        imei: imei.replace('"', '').replace('"', ''),
                        iccid: iccid ? iccid.replace('"', '').replace('"', '') : null,
                        Error: error,
                        Message: message,
                        Selected: error === 0 ? true : false

                    }

                    result.Devices.push(device);
                } else {
                    let device = {
                        esn: serial,
                        imei: imei,
                        Error: 1,
                        Message: "devices_import_missing_imei_or_serial",
                    }
                    result.Devices.push(device);
                }
            }
        }
        yield put(devicesImportProcessCsvResult(result));
    } catch (exc) {
        //```always return empty data
        yield put(devicesImportProcessCsvResult({ error: exc }));
        //```catch error
        ExceptionManager(exc, "Modules/devices/.components/importDevices/redux/saga/", "processCsvSmartWitnessImportRequest");
    }
}   

function* watchMethods() {
    yield takeEvery(DEVICES_IMPORT_PROCESS_CSV, processCsvImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_PUI_CSV, processPUICsvImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_QUECLINK_CSV, processCsvQueclinkImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_CALAMP_CSV, processCalampCsvImportRequest);
    yield takeEvery(DEVICES_IMPORT_GET_DEVICE_MODEL, getDeviceModel);
    yield takeEvery(DEVICES_IMPORT_LOAD_PHONE_NUMBERS, loadPhoneNumbers);
    yield takeEvery(DEVICES_IMPORT_SAVE, importDevicesRequest);
    yield takeEvery(DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO, getCalampDeviceInfoImportRequest);

    yield takeEvery(DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV, processGeometrisCsvImportRequest);
    yield takeEvery(DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO, getGeometrisDeviceInfoImportRequest);

    yield takeEvery(DEVICES_IMPORT_PROCESS_CEREBRUMX_CSV, processCerebrumXCsvImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_TELITEK_CSV, processCsvTelitekImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_PACIFIC_TRACK_CSV, processCsvPacificTrackImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_ZONAR_CSV, processCsvZonarImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_GENX_CSV, processCsvGenXImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_DIGITAL_MATTERS_CSV, processCsvDigitalMattersImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_LIGHTMETRICS_CSV, processCsvLightMetricsImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_M2MD_CSV, processCsvM2MDImportRequest);
    yield takeEvery(DEVICES_IMPORT_PROCESS_SMARTWITNESS_CSV, processCsvSmartWitnessImportRequest);

}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}